import moment from "moment"

import { IModalApplicationsPromoUI } from "./types"

import CommonService from "@services/common.service"
import { ComponentsHeader } from "@primitive/sectionHeadings"

import { Button, Drawer, Empty, Flex, Loader, Pagination, ToolTip, Table } from "@ui/index"

import imgEmty from '@img/empty.svg'
import { IconArchiveAdd, IconArchiveDelete, IconClearClose, IconPromo, IconTelegram } from "@img/icons"

import css from './ui.module.scss'


/** Список промо-заявки */
export const ModalApplicationsPromoUI = ({ 
    isOpen, isLoadingPage, txtSearch, paginationPageNumber,
    filterIsOpen, filterIsActivate,
    applicationsList, applicationsPageSize, applicationsTotalCount,
    
    setTxtSearch, loadPrimaryData,
    handleButtonCancel, handleApplyClearFilter, 
    handleSendToTelegram, handleOpenModalConfirm,
}: IModalApplicationsPromoUI) => {
    const footer = (
        <div className={css['footer']}>
            <Flex gap="4px" flexDirection="row">
                <p className={css.stat_all}>{applicationsTotalCount}</p>
            </Flex>
            <Pagination
                totalCount={applicationsTotalCount}
                pageSize={applicationsPageSize}
                currentPage={paginationPageNumber.value}
                onChange={(e) => paginationPageNumber.setValue(e)}
            />
        </div>
    )

    return <>
        <Drawer isOpen={isOpen} placement='bottom' size='100%'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <header>
                        <Flex gap='4px' flexDirection='row' alignItems='center'>
                            <IconPromo color='#fff' width='20px' height='20px' />
                            <h4>Промо-заявки</h4>
                        </Flex>
                    </header>

                    <Button variant='icon' size='md' onClick={handleButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body'>
                    <Flex gap='6px' className={`drawer_container-content ${css.content}`} overflowY='hidden' padding='2px 0px 0px 0px'>

                        <ComponentsHeader
                            inline
                            txtSearch={txtSearch} 
                            txtSearchTooltip={<>Поиск по:<br />✓ Имени<br />✓ Телефону<br />✓ Email<br />✓ Идентификатору заявки<br />✓ Наименованию курса<br />✓ Комментарию</>}
                            txtSearchOnChange={(e) => setTxtSearch(e.target.value)}
                            txtSearchClearOnClick={() => setTxtSearch('')}
                            btnUpdateOnClick={() => loadPrimaryData(txtSearch)}
                            btnFilterOnClick={() => filterIsOpen.setValue(true)}
                            btnFilterClearOnClick={() => handleApplyClearFilter('clear')}
                            filterIsActivate={filterIsActivate.value}
                        />

                        <Table.Container footer={footer}>
                            <Loader isOpen={isLoadingPage} backdrop title="Загрузка..." color="var(--color_txt_accent)" />
                            <Table.Header paddingLeft="8px" paddingRight="14px" classNameContent={css['table_grid_columns_header']}>
                                <p style={{ textAlign: 'center' }}>№<br />заявки</p>

                                <div className={css.hidden_650}>
                                    <p>Имя клиента</p>
                                    <p>Телефон клиента</p>
                                </div>

                                <div className={css.hidden_650}>
                                    <p>Комментарий</p>
                                    <p>Часы / Программа</p>
                                </div>

                                <p className={css.hidden_1100} style={{textAlign:'center'}}>Статус<br />заявки</p>
                                <p className={css.hidden_1000} style={{textAlign:'center'}}>Дата<br />создания</p>
                                <p></p>
                            </Table.Header>

                            <Table.Content>
                                {applicationsList.length === 0 
                                    ? <Empty image={imgEmty} title='Данные отсутствуют' /> 
                                    : applicationsList.map((item, index) => {
                                        return (
                                            <Table.Row key={`${index}`} className={css['table_grid_columns_content']}>
                                                <div style={{
                                                    color: '#ffffff',
                                                    textAlign: 'center',
                                                    padding: '4px 0px',
                                                    lineHeight: '160%',
                                                    background: item.applicationStatusColor,
                                                    borderRadius: 'calc(var(--border_radius_default) - 4px)',
                                                }}>{item.appTmpID}</div>

                                                <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                    <p>{item.clientName}</p>
                                                    <p style={{opacity:'.7'}}>{item.clientPhone}</p>
                                                </div>

                                                <div className={css.hidden_650} style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                    <p>{item.comment || '------'}</p>
                                                    <p style={{opacity:'.7'}}>{item.volumeHours ? CommonService.formatHours(item.volumeHours) : '------'} / {item.courseName || '------'}</p>
                                                </div>

                                                <div className={css.hidden_1100} style={{textAlign:'center', color: item.applicationStatusColor}}>{item.applicationStatusName}</div>
                                                
                                                <div className={css.hidden_1000} style={{textAlign:'center'}}>{moment(item.dateCreate).format('DD.MM.YYYY')}<br />{moment(item.dateCreate).format('HH:mm:ss')}</div>
                                            
                                                <Flex gap="4px" flexDirection="row">
                                                    <ToolTip title='В ИКТ - Промо МАКПП' placement="bottomRight">
                                                        <Button variant="icon" size="sm" 
                                                            onClick={() => handleSendToTelegram(item.appTmpID)}
                                                        ><IconTelegram width="20px" height="20px" /></Button>
                                                    </ToolTip>

                                                    <ToolTip title='В архив' placement="bottomRight">
                                                        <Button variant="icon" size="sm" onClick={(e) => {
                                                            handleOpenModalConfirm(true, 'Отправка в архив', 
                                                                `${item.isArchive === 0 
                                                                    ? `Вы действительно хотите отправить заявку № ${item.appTmpID} в архив?` 
                                                                    : `Вы действительно хотите удалить заявку № ${item.appTmpID} из архива?`}
                                                                `, item.appTmpID, "toArchiveList", item.isArchive
                                                            )
                                                            e.stopPropagation()
                                                        }}>
                                                            {item.isArchive === 0 ? <IconArchiveAdd width="20px" height="20px" /> : <IconArchiveDelete width="20px" height="20px" color="green" />} 
                                                        </Button>
                                                    </ToolTip>
                                                </Flex>
                                            </Table.Row>
                                        )
                                    })
                                }
                            </Table.Content>
                        </Table.Container>


                        {/* <div className={css.content}>
                            <Table.Header classGridTemplateColumns={css.grid_template_columns_header}>
                                <div className={css.hidden_650}></div>
                                <div className={css.hidden_650}>
                                    <h5>Имя клиента</h5>
                                    <h5>Телефон клиента</h5>
                                </div>

                                <div className={css.hidden_650}>
                                    <h5>Комментарий</h5>
                                    <h5>Часы / Программа</h5>
                                </div>

                                <h5 className={css.hidden_1100} style={{textAlign:'center'}}>Статус заявки</h5>
                                <h5 className={css.hidden_1000} style={{textAlign:'center'}}>Дата создания</h5>
                                <div></div>
                            </Table.Header>

                            <Table.Content>
                                {applicationsList.length === 0 
                                    ? <Empty image={imgEmty} title='Данные отсутствуют' /> 
                                    : applicationsList.map((item, index) => {
                                        return (
                                            <Table.Row 
                                                key={`${index}`} 
                                                header={`${item.appTmpID}`} 
                                                headerWidth="80px" navWidth="72px"
                                                headerBackground={item.applicationStatusColor} 
                                                classGridTemplateColumns={css.grid_template_columns_rows}
                                                childrenNav={<>
                                                    <Button id='tooltipBtnSendedTelegram' variant="icon" size="xs" 
                                                        onClick={() => handleSendToTelegram(item.appTmpID)}
                                                    ><IconTelegram /></Button>

                                                    <Button 
                                                        id='tooltipBtnToArchive' variant="icon" size="xs" 
                                                        onClick={(e) => {handleOpenModalConfirm(true, 'Отправка в архив', `${item.isArchive === 0 ? `Вы действительно хотите отправить заявку № ${item.appTmpID} в архив?` : `Вы действительно хотите удалить заявку № ${item.appTmpID} из архива?`}`, item.appTmpID, "toArchiveList", item.isArchive); e.stopPropagation()}}
                                                    >
                                                        {item.isArchive === 0 ? <IconArchiveAdd /> : <IconArchiveDelete color="green" />} 
                                                    </Button>
                                                </>} >

                                                <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                    <p>{item.clientName}</p>
                                                    <p style={{opacity:'.7'}}>{item.clientPhone}</p>
                                                </div>

                                                <div className={css.hidden_650} style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                    <p>{item.comment || '------'}</p>
                                                    <p style={{opacity:'.7'}}>{item.volumeHours ? CommonService.formatHours(item.volumeHours) : '------'} / {item.courseName || '------'}</p>
                                                </div>

                                                <div className={css.hidden_1100} style={{textAlign:'center', color: item.applicationStatusColor}}>{item.applicationStatusName}</div>
                                                
                                                <div className={css.hidden_1000} style={{textAlign:'center'}}>{moment(item.dateCreate).format('DD.MM.YYYY')}<br />{moment(item.dateCreate).format('HH:mm:ss')}</div>
                                            </Table.Row>
                                        )
                                    })
                                }
                            </Table.Content>
                        </div> */}

                        
                    </Flex>
                </Flex>
            </Flex>
        </Drawer>
    </>
}
